{
    "searchResults": {
        "root": "agent-search",
        "rootLoading": "agent-search--loading",
        "status": "agent-search-results__status",
        "loading": "agent-search-results__loading agent-search-visually-hidden",
        "error": "agent-search-message agent-search-message--error alert alert-danger",
        "rateLimited": "agent-search-message agent-search-message--rate-limited alert alert-warning",
        "empty": "agent-search-message alert alert-warning",
        "count": "agent-search-results__count",
        "countNumber": "agent-search-results__count-number",
        "area": "agent-search-results-area",
        "results": "agent-search-results",
        "skeletonList": "agent-search-block__list agent-search-skeleton",
        "skeletonItem": "agent-search-block__item"
    },
    "searchForm": {
        "form": "agent-search-form",
        "label": "agent-search-form__label",
        "input": "form-control agent-search-form__input",
        "submit": "btn btn-primary agent-search-form__submit",
        "error": "agent-search-form__error invalid-feedback"
    },
    "resultBlock": {
        "block": "agent-search-block",
        "blockTypePrefix": "agent-search-block--",
        "title": "agent-search-block__title",
        "titleHidden": "agent-search-visually-hidden",
        "error": "agent-search-message agent-search-message--error alert alert-danger agent-search-block__error",
        "list": "agent-search-block__list",
        "item": "agent-search-block__item"
    },
    "pagination": {
        "nav": "agent-search-pagination",
        "list": "pagination agent-search-pagination__list",
        "item": "page-item agent-search-pagination__item",
        "itemActive": "active",
        "itemDisabled": "disabled",
        "link": "page-link agent-search-pagination__link",
        "linkCurrent": "agent-search-pagination__link--current",
        "linkDisabled": "agent-search-pagination__link--disabled",
        "linkPrev": "agent-search-pagination__link--prev",
        "linkNext": "agent-search-pagination__link--next",
        "gap": "page-link agent-search-pagination__gap"
    },
    "teaser": {
        "teaser": "agent-search-teaser",
        "teaserHasImage": "agent-search-teaser--has-image",
        "image": "agent-search-teaser__image",
        "body": "agent-search-teaser__body",
        "title": "agent-search-teaser__title",
        "link": "agent-search-teaser__link",
        "snippet": "agent-search-teaser__snippet",
        "highlight": "agent-search-teaser__highlight",
        "url": "agent-search-teaser__url"
    },
    "teaserSkeleton": {
        "teaser": "agent-search-teaser agent-search-teaser--has-image agent-search-teaser--skeleton",
        "image": "agent-search-teaser__image",
        "imagePlaceholder": "agent-search-skeleton__image",
        "body": "agent-search-teaser__body",
        "line": "agent-search-skeleton__line",
        "lineTitle": "agent-search-skeleton__line--title",
        "lineShort": "agent-search-skeleton__line--short",
        "lineUrl": "agent-search-skeleton__line--url"
    }
}
